import React from 'react';
import { useFretsStore } from '../../../store/useFretsStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

import NavCloseButton from '../CloseButton/CloseButton.component';

export const CloseButton = () => {
    const show = useFretsStore(state => state.showNav);
    return <span className="legacy-nav-close-wrapper">
        <NavCloseButton className={'legacy-nav-close-button ' + (show ? 'is-visible' : '')}>
            <FontAwesomeIcon icon={faCaretLeft} />
        </NavCloseButton>
    </span>;
};

export default CloseButton;